function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M573 88.935L574.064 87.7747C575.031 86.6145 576.771 86.5178 577.931 87.4847L579.092 88.5483L580.832 86.5178L579.672 85.4542C578.511 84.4873 578.415 82.7469 579.382 81.5867L580.445 80.4264L578.415 78.686L577.351 79.8463C576.384 81.0066 574.644 81.1032 573.484 80.1364L572.323 79.0728L570.583 81.1032L571.743 82.1668C572.904 83.1337 573 84.8741 572.033 86.0344L570.97 87.1946L573 88.935Z",
  fill: "#2B1C1C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M513.344 139.503L513.924 138.826C514.504 138.149 515.471 138.149 516.148 138.633L516.825 139.213L517.888 138.053L517.211 137.473C516.535 136.892 516.535 135.926 517.018 135.249L517.598 134.572L516.438 133.508L515.858 134.185C515.278 134.862 514.311 134.862 513.634 134.378L512.957 133.798L511.894 134.959L512.57 135.539C513.247 136.119 513.247 137.086 512.764 137.763L512.184 138.439L513.344 139.503Z",
  fill: "#2B1C1C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M607.905 179.049L608.388 178.565C608.775 178.082 609.549 177.985 610.032 178.469L610.515 178.952L611.289 178.082L610.805 177.598C610.322 177.212 610.225 176.438 610.709 175.955L611.192 175.471L610.322 174.698L609.839 175.181C609.452 175.665 608.678 175.761 608.195 175.278L607.711 174.794L606.938 175.665L607.421 176.148C607.905 176.535 608.002 177.308 607.518 177.792L607.035 178.275L607.905 179.049Z",
  fill: "#2B1C1C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M561.204 148.205L561.784 147.528C562.364 146.851 563.331 146.851 564.008 147.335L564.685 147.915L565.749 146.755L565.072 146.175C564.395 145.595 564.395 144.628 564.878 143.951L565.459 143.274L564.298 142.21L563.718 142.887C563.138 143.564 562.171 143.564 561.494 143.081L560.817 142.501L559.754 143.661L560.431 144.241C561.108 144.821 561.108 145.788 560.624 146.465L560.044 147.142L561.204 148.205Z",
  fill: "#2B1C1C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M548.635 206.508L548.925 206.121C549.215 205.831 549.698 205.735 549.989 206.025L550.375 206.315L550.859 205.735L550.472 205.445C550.182 205.154 550.085 204.671 550.375 204.381L550.665 203.994L550.085 203.511L549.795 203.898C549.505 204.188 549.022 204.284 548.732 203.994L548.345 203.704L547.861 204.284L548.248 204.574C548.538 204.864 548.635 205.348 548.345 205.638L548.055 206.025L548.635 206.508Z",
  fill: "#2B1C1C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M521.852 259.493L522.045 259.3C522.142 259.107 522.432 259.107 522.626 259.3L522.819 259.493L523.109 259.203L522.916 259.01C522.722 258.913 522.722 258.623 522.916 258.43L523.109 258.236L522.819 257.946L522.626 258.14C522.529 258.333 522.239 258.333 522.045 258.14L521.852 257.946L521.562 258.236L521.755 258.43C521.949 258.526 521.949 258.816 521.755 259.01L521.562 259.203L521.852 259.493Z",
  fill: "#2B1C1C"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M575.321 191.618L575.611 191.231C575.901 190.941 576.384 190.844 576.675 191.135L577.061 191.425L577.545 190.844L577.158 190.554C576.868 190.264 576.771 189.781 577.061 189.491L577.351 189.104L576.771 188.621L576.481 189.007C576.191 189.297 575.708 189.394 575.418 189.104L575.031 188.814L574.547 189.394L574.934 189.684C575.224 189.974 575.321 190.458 575.031 190.748L574.741 191.135L575.321 191.618Z",
  fill: "#2B1C1C"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M593.885 227.393L594.175 227.006C594.465 226.716 594.949 226.619 595.239 226.909L595.626 227.199L596.109 226.619L595.722 226.329C595.432 226.039 595.336 225.556 595.626 225.266L595.916 224.879L595.336 224.396L595.046 224.782C594.756 225.072 594.272 225.169 593.982 224.879L593.595 224.589L593.112 225.169L593.499 225.459C593.789 225.749 593.885 226.233 593.595 226.523L593.305 226.909L593.885 227.393Z",
  fill: "#2B1C1C"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M576.288 235.031L576.578 234.644C576.868 234.354 577.351 234.258 577.641 234.548L578.028 234.838L578.512 234.258L578.125 233.967C577.835 233.677 577.738 233.194 578.028 232.904L578.318 232.517L577.738 232.034L577.448 232.42C577.158 232.711 576.674 232.807 576.384 232.517L575.998 232.227L575.514 232.807L575.901 233.097C576.191 233.387 576.288 233.871 575.998 234.161L575.708 234.548L576.288 235.031Z",
  fill: "#2B1C1C"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M555.597 113.784L555.79 113.59C555.887 113.397 556.177 113.397 556.37 113.59L556.564 113.784L556.854 113.494L556.66 113.3C556.467 113.204 556.467 112.914 556.66 112.72L556.854 112.527L556.564 112.237L556.37 112.43C556.273 112.624 555.983 112.624 555.79 112.43L555.597 112.237L555.307 112.527L555.5 112.72C555.693 112.817 555.693 113.107 555.5 113.3L555.307 113.494L555.597 113.784Z",
  fill: "#2B1C1C"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M508.413 93.3826L508.703 92.9958C508.993 92.7058 509.476 92.6091 509.766 92.8992L510.153 93.1892L510.637 92.6091L510.25 92.319C509.96 92.029 509.863 91.5455 510.153 91.2554L510.443 90.8687L509.863 90.3853L509.573 90.772C509.283 91.0621 508.799 91.1588 508.509 90.8687L508.123 90.5786L507.639 91.1588L508.026 91.4488C508.316 91.7389 508.413 92.2223 508.123 92.5124L507.833 92.8992L508.413 93.3826Z",
  fill: "#2B1C1C"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M526.88 116.008L527.17 115.621C527.46 115.331 527.944 115.234 528.234 115.524L528.62 115.814L529.104 115.234L528.717 114.944C528.427 114.654 528.33 114.171 528.62 113.88L528.91 113.494L528.33 113.01L528.04 113.397C527.75 113.687 527.267 113.784 526.977 113.494L526.59 113.204L526.106 113.784L526.493 114.074C526.783 114.364 526.88 114.847 526.59 115.137L526.3 115.524L526.88 116.008Z",
  fill: "#2B1C1C"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M538.096 81.8766L538.289 81.6832C538.386 81.4899 538.676 81.4899 538.869 81.6832L539.063 81.8766L539.353 81.5865L539.159 81.3932C538.966 81.2965 538.966 81.0064 539.159 80.813L539.353 80.6197L539.063 80.3296L538.869 80.523C538.773 80.7163 538.482 80.7163 538.289 80.523L538.096 80.3296L537.806 80.6197L537.999 80.813C538.192 80.9097 538.192 81.1998 537.999 81.3932L537.806 81.5865L538.096 81.8766Z",
  fill: "#2B1C1C"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M594.272 134.669L594.465 134.475C594.562 134.282 594.852 134.282 595.045 134.475L595.239 134.669L595.529 134.379L595.336 134.185C595.142 134.088 595.142 133.798 595.336 133.605L595.529 133.412L595.239 133.122L595.045 133.315C594.949 133.508 594.659 133.508 594.465 133.315L594.272 133.122L593.982 133.412L594.175 133.605C594.369 133.702 594.369 133.992 594.175 134.185L593.982 134.379L594.272 134.669Z",
  fill: "#2B1C1C"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M622.505 212.019L622.698 211.826C622.795 211.632 623.085 211.632 623.278 211.826L623.472 212.019L623.762 211.729L623.569 211.536C623.375 211.439 623.375 211.149 623.569 210.956L623.762 210.762L623.472 210.472L623.278 210.666C623.182 210.859 622.892 210.859 622.698 210.666L622.505 210.472L622.215 210.762L622.408 210.956C622.602 211.052 622.602 211.342 622.408 211.536L622.215 211.729L622.505 212.019Z",
  fill: "#2B1C1C"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M604.618 261.33L604.811 261.137C604.908 260.943 605.198 260.943 605.391 261.137L605.585 261.33L605.875 261.04L605.681 260.847C605.488 260.75 605.488 260.46 605.681 260.267L605.875 260.073L605.585 259.783L605.391 259.977C605.295 260.17 605.004 260.17 604.811 259.977L604.618 259.783L604.328 260.073L604.521 260.267C604.714 260.363 604.714 260.653 604.521 260.847L604.328 261.04L604.618 261.33Z",
  fill: "#2B1C1C"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M551.536 290.627L551.729 290.434C551.826 290.24 552.116 290.24 552.309 290.434L552.503 290.627L552.793 290.337L552.503 290.144C552.309 290.047 552.309 289.757 552.503 289.564L552.696 289.37L552.406 289.08L552.213 289.273C552.116 289.467 551.826 289.467 551.632 289.273L551.439 289.08L551.149 289.37L551.342 289.564C551.536 289.66 551.536 289.95 551.342 290.144L551.149 290.337L551.536 290.627Z",
  fill: "#2B1C1C"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M531.521 171.314L531.811 170.927C532.101 170.637 532.585 170.54 532.875 170.83L533.261 171.12L533.745 170.54L533.358 170.25C533.068 169.96 532.971 169.477 533.261 169.187L533.552 168.8L533.165 168.316L532.875 168.703C532.585 168.993 532.101 169.09 531.811 168.8L531.424 168.51L530.941 169.09L531.328 169.38C531.618 169.67 531.714 170.153 531.424 170.444L531.134 170.83L531.521 171.314Z",
  fill: "#2B1C1C"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M528.427 227.103L528.717 226.716C529.007 226.426 529.49 226.329 529.78 226.619L530.167 226.909L530.651 226.329L530.264 226.039C529.974 225.749 529.877 225.266 530.167 224.976L530.457 224.589L529.877 224.105L529.587 224.492C529.297 224.782 528.814 224.879 528.524 224.589L528.137 224.299L527.653 224.879L528.04 225.169C528.33 225.459 528.427 225.943 528.137 226.233L527.847 226.619L528.427 227.103Z",
  fill: "#2B1C1C"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M565.072 286.953H553.469V465.827H565.072V286.953Z",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M218.928 465.762L230.53 465.762L230.53 286.888L218.928 286.888L218.928 465.762Z",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M428.258 223.429H355.742V271.773H428.258V223.429Z",
  fill: "white",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M451.463 263.748H332.536V271.483H451.463V263.748Z",
  fill: "white",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M783.588 463.893H0.411621V467.76H783.588V463.893Z",
  fill: "#2B1C1C"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M492.556 223.429H291.444C282.935 223.429 275.974 216.467 275.974 207.958V84.1972C275.974 75.6886 282.935 68.7271 291.444 68.7271H492.556C501.064 68.7271 508.026 75.6886 508.026 84.1972V207.958C508.026 216.467 501.064 223.429 492.556 223.429Z",
  fill: "white",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M508.026 192.488H275.974V84.1972C275.974 75.6886 282.935 68.7271 291.444 68.7271H492.556C501.064 68.7271 508.026 75.6886 508.026 84.1972V192.488Z",
  fill: "#2B1C1C"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5626 464.473L102.515 341.582L93.0393 339.165C91.0088 337.424 88.3982 338.585 87.3347 341.582L45.1785 461.475C44.0183 464.763 47.209 467.567 48.5626 464.473Z",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M177.545 464.473L123.593 341.582L133.068 339.165C135.099 337.424 137.709 338.585 138.773 341.582L180.929 461.475C182.089 464.763 178.899 467.567 177.545 464.473Z",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M392 214.63C395.844 214.63 398.961 211.513 398.961 207.669C398.961 203.824 395.844 200.707 392 200.707C388.155 200.707 385.038 203.824 385.038 207.669C385.038 211.513 388.155 214.63 392 214.63Z",
  fill: "#2B1C1C"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M609.162 283.085H174.741V290.821H609.162V283.085Z",
  fill: "#2B1C1C"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M155.113 342.065H93.0389C66.4496 342.065 44.8881 320.504 44.8881 293.914V287.34C44.8881 271.676 42.6642 256.013 38.2166 241.026L35.2192 230.874",
  stroke: "#2B1C1C",
  strokeWidth: 12,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M95.5527 357.439L136.065 370.008",
  stroke: "#382929",
  strokeMiterlimit: 10
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M131.811 361.403L88.3013 374.843",
  stroke: "#382929",
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M88.1079 374.939L146.798 393.02",
  stroke: "#382929",
  strokeMiterlimit: 10
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M140.61 380.547L77.5688 400.078",
  stroke: "#382929",
  strokeMiterlimit: 10
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M628.887 271.483H155.113V283.086H628.887V271.483Z",
  fill: "#2B1C1C"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M669.302 308.321C671.042 308.128 672.879 308.224 674.523 308.901C678.004 310.351 678.971 314.412 678.874 317.7C678.777 321.277 678.101 325.145 680.808 328.045C682.065 329.399 683.612 330.366 684.772 331.719C686.029 333.17 687.093 334.814 687.866 336.554C689.22 339.745 689.897 343.612 688.64 346.996C687.479 349.994 684.675 352.701 685.352 356.085C686.029 359.662 689.607 362.37 691.83 364.98C694.344 367.978 696.665 371.749 697.052 375.713C697.438 379.484 695.795 383.254 693.281 386.058C688.253 391.763 680.711 394.47 673.17 394.47C669.979 394.47 666.305 394.277 663.501 392.537C662.63 391.956 662.147 391.376 661.664 390.603C661.18 389.829 660.6 389.346 659.923 388.862C658.376 387.702 657.313 386.155 656.539 384.415C653.735 377.55 655.959 369.138 659.827 363.047C660.697 361.596 661.47 360.243 661.083 358.502C660.6 356.762 659.44 355.118 658.473 353.571C657.506 352.024 656.346 350.574 655.572 348.93C654.799 347.19 654.509 345.449 654.702 343.515C654.992 339.938 656.539 336.747 658.666 333.847C660.793 331.139 663.211 328.529 663.211 324.951C663.211 321.18 660.697 317.796 661.76 313.929C662.244 312.285 663.114 310.641 664.564 309.771C665.821 308.804 667.658 308.514 669.302 308.321Z",
  fill: "#2B1C1C"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M668.238 314.412C668.238 313.929 668.915 313.639 669.399 313.735C669.979 313.929 669.979 314.509 669.979 314.992C669.882 316.636 670.172 318.183 670.559 319.73C671.332 322.921 672.879 325.918 674.04 329.109C675.2 332.203 675.78 335.394 675.103 338.681C674.426 341.775 673.459 344.772 672.783 347.866C672.202 350.574 671.622 353.474 672.493 356.182C673.363 358.792 675.2 360.919 676.65 363.336C679.454 368.268 680.711 373.682 680.904 379.29C681.001 381.901 680.904 384.511 680.324 387.122C679.938 388.572 679.551 390.603 678.294 391.569C677.714 392.053 676.747 392.246 676.263 391.473C675.78 390.796 676.167 389.829 676.36 389.152C677.037 386.155 677.134 383.061 676.94 380.064C676.747 377.066 676.457 374.166 675.49 371.362C674.62 368.751 673.363 366.431 671.816 364.11C670.269 361.789 668.625 359.469 667.948 356.665C667.271 353.861 667.851 350.96 668.528 348.253C669.302 345.352 670.269 342.548 671.332 339.648C672.299 336.844 672.686 334.233 672.106 331.333C670.752 325.725 667.851 320.31 668.238 314.412Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M715.326 315.186C717.453 315.862 719.58 316.926 721.127 318.57C724.414 322.051 723.351 327.368 721.61 331.333C719.677 335.49 716.776 339.745 718.42 344.482C719.193 346.706 720.45 348.64 721.224 350.864C721.997 353.281 722.287 355.698 722.287 358.212C722.19 362.756 721.03 367.591 717.743 370.975C714.842 373.972 710.104 375.616 709.041 379.967C707.881 384.511 710.685 389.539 711.941 393.793C713.295 398.628 714.069 404.332 712.425 409.167C710.878 413.808 706.914 417.482 702.466 419.512C693.571 423.573 683.322 422.993 674.426 419.029C670.656 417.385 666.401 415.258 664.081 411.777C663.307 410.714 663.114 409.747 663.017 408.49C662.92 407.33 662.437 406.459 661.857 405.493C660.697 403.269 660.213 400.852 660.31 398.434C660.697 388.959 667.755 380.064 675.49 374.939C677.327 373.682 678.971 372.425 679.357 370.201C679.744 367.881 679.261 365.367 678.874 363.046C678.487 360.726 677.907 358.405 677.907 356.085C677.907 353.668 678.584 351.347 679.744 349.22C681.968 345.159 685.449 342.162 689.51 339.841C693.377 337.714 697.632 335.877 699.565 331.623C701.596 327.175 700.436 321.857 703.723 317.796C705.077 316.153 707.01 314.702 709.234 314.315C710.975 314.025 713.295 314.605 715.326 315.186Z",
  fill: "#2B1C1C"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M710.878 322.631C711.168 322.051 712.038 321.954 712.522 322.437C713.199 323.018 712.812 323.694 712.522 324.275C711.652 326.112 711.071 328.142 710.685 330.173C709.911 334.427 710.105 338.778 709.815 343.032C709.524 347.286 708.558 351.444 705.947 354.925C703.53 358.212 700.823 361.306 698.405 364.594C696.278 367.494 694.054 370.588 693.668 374.359C693.281 377.937 694.344 381.417 694.731 384.995C695.505 392.343 694.054 399.401 691.347 406.17C690.09 409.264 688.64 412.358 686.609 415.065C685.449 416.612 683.805 418.739 681.872 419.319C680.905 419.609 679.744 419.223 679.454 418.159C679.261 417.192 680.228 416.129 680.808 415.452C683.129 412.261 684.869 408.684 686.319 405.009C687.673 401.432 688.833 397.758 689.22 393.89C689.607 390.313 689.317 386.832 688.64 383.351C688.06 379.774 687.383 376.1 688.06 372.522C688.736 368.848 690.864 365.754 693.184 362.853C695.601 359.759 698.212 356.955 700.919 354.151C703.53 351.444 705.367 348.543 706.14 344.772C707.977 337.424 707.301 329.496 710.878 322.631Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M649.964 347.093C653.542 347.093 656.732 349.027 658.859 351.637C661.373 354.828 661.954 358.599 662.92 362.37C663.404 364.207 664.274 366.14 665.821 367.397C667.271 368.558 669.012 368.751 670.655 369.331C674.04 370.491 676.747 373.199 677.81 376.486C679.164 380.547 677.714 384.608 678.004 388.669C678.197 392.44 681.968 394.76 684.965 396.597C687.866 398.338 690.573 400.078 691.443 403.462C692.41 407.136 692.7 411.197 691.443 414.871C689.316 420.963 682.935 423.573 676.747 423.96C671.139 424.347 664.177 423.767 660.02 419.706C657.506 417.289 656.636 413.904 656.732 410.52C656.829 408.393 657.216 406.363 657.796 404.332C658.183 402.882 658.666 401.432 658.859 399.981C659.246 396.017 655.572 395.244 652.478 394.18C648.514 392.826 645.807 390.216 643.873 386.638C642.132 383.254 641.359 379.483 642.422 375.809C643.003 373.875 643.969 372.232 645.323 370.781C645.903 370.105 646.773 369.621 647.257 368.944C647.74 368.268 647.644 367.494 647.45 366.721C646.677 363.336 644.163 360.436 643.293 357.052C642.519 353.958 643.003 350.187 645.807 348.156C646.967 347.48 648.417 347.093 649.964 347.093Z",
  fill: "white",
  stroke: "#382929",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M654.798 355.988C658.569 360.049 659.633 365.56 659.923 370.878C660.116 373.875 659.923 376.969 660.793 379.87C661.567 382.384 663.307 384.221 665.144 386.058C668.818 389.636 672.879 393.31 673.943 398.531C674.523 401.625 674.136 404.719 675.006 407.813C675.78 410.52 677.133 413.228 678.874 415.548C680.227 417.385 681.968 418.835 683.515 420.576C683.998 421.059 684.578 421.929 684.385 422.606C684.192 423.476 683.031 423.767 682.258 423.67C680.421 423.38 678.874 421.543 677.617 420.286C675.877 418.449 674.33 416.418 673.073 414.098C671.719 411.584 670.655 408.877 670.172 406.073C669.688 403.172 669.882 400.078 668.818 397.274C666.981 392.536 662.437 389.732 659.149 386.058C655.088 381.417 655.669 375.712 656.055 370.104C656.249 367.01 656.539 363.53 654.895 360.629C654.315 359.565 652.961 358.502 652.671 357.342C652.575 356.085 653.832 354.924 654.798 355.988Z",
  fill: "#2B1C1C"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M708.171 465.826H656.926C640.876 465.826 629.273 450.549 633.431 435.079L638.555 416.515H726.542L731.666 435.079C735.92 450.549 724.221 465.826 708.171 465.826Z",
  fill: "#2B1C1C"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M736.21 408.78H628.886V416.515H736.21V408.78Z",
  fill: "#2B1C1C"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 440.591,
  cy: 95.4359,
  r: 95.1967,
  fill: "#2B1C1C"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 462.252,
  cy: 82.8124,
  r: 8.28117,
  fill: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("circle", {
  cx: 421.65,
  cy: 82.8124,
  r: 8.28117,
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M470.047 121.613C471.537 120.079 471.549 117.621 469.93 116.223C466.534 113.289 462.716 110.901 458.605 109.148C453.325 106.897 447.666 105.739 441.951 105.739C436.236 105.739 430.577 106.897 425.297 109.148C421.187 110.901 417.368 113.289 413.972 116.223C412.353 117.621 412.365 120.079 413.855 121.613C415.408 123.211 417.962 123.192 419.685 121.778C422.293 119.638 425.186 117.88 428.28 116.561C432.615 114.713 437.26 113.762 441.951 113.762C446.642 113.762 451.288 114.713 455.622 116.561C458.716 117.88 461.609 119.638 464.218 121.778C465.94 123.192 468.494 123.211 470.047 121.613Z",
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 491.611,
  y: 160.828,
  width: 18,
  height: 71.4595,
  rx: 9,
  transform: "rotate(-45 491.611 160.828)",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M440.591 171.633C482.673 171.633 516.787 137.518 516.787 95.4359C516.787 53.3537 482.673 19.2393 440.591 19.2393C398.508 19.2393 364.394 53.3537 364.394 95.4359C364.394 137.518 398.508 171.633 440.591 171.633ZM534.787 95.4359C534.787 147.459 492.614 189.633 440.591 189.633C388.567 189.633 346.394 147.459 346.394 95.4359C346.394 43.4125 388.567 1.23926 440.591 1.23926C492.614 1.23926 534.787 43.4125 534.787 95.4359Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 784,
    height: 468,
    viewBox: "0 0 784 468",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.55d8ddc1.svg";
export { ForwardRef as ReactComponent };